import { CSSObject, styled, Theme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';

const openedMixin = (width: number | string): CSSObject => ({
  width: width,
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme, width: number | string): CSSObject => ({
  overflowX: 'hidden',
  width: width,
  [theme.breakpoints.up('sm')]: {
    width: width,
  },
});

type DrawerProps = {
  open: boolean;
  collapsedWidth: string | number;
  expandedWidth: string | number;
};

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open' && prop != 'collapsedWidth' && prop != 'expandedWidth',
})<DrawerProps>(({ theme, open, collapsedWidth, expandedWidth }) => ({
  width: expandedWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(expandedWidth),
    '& .MuiDrawer-paper': openedMixin(expandedWidth),
  }),
  ...(!open && {
    ...closedMixin(theme, collapsedWidth),
    '& .MuiDrawer-paper': closedMixin(theme, collapsedWidth),
  }),
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  color: 'darkblue',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
